import React, { Component } from 'react';
import { Panel } from 'react-bootstrap'
//Library for cookies
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { apiService } from '../service/Apiservice'
import { withTranslation } from "react-i18next";
class Bulp extends Component {
	static propTypes = {
		cookies: instanceOf(Cookies).isRequired
	};
	constructor(props) {
		super(props);
		this.state = {
			openBulp: true,
			selectedBulpName: '',
			selectedTehnology: {}
		}

	}

	////////////COOKIE END

	////////////SELECTION
	selectBulp = (event) => {
		const selectedBulpValue = event.currentTarget.getAttribute('value')
		const selectedBulpID = event.currentTarget.getAttribute('id')
		
		this.handleSelectedBulp(selectedBulpValue, selectedBulpID)
	}

	handleSelectedBulp = (value, id) => {
		var selectedBulpValue = parseInt(value, 10)
		var selectedBulpID = id
		if (!selectedBulpID && this.props.bulps) {
			this.props.bulps.filter(bulp => bulp.use_id === selectedBulpValue).map(bulp => selectedBulpID = bulp.use_name)
		}
		if (selectedBulpID) {
			this.setState({
				selectedBulpName: selectedBulpID,
				openBulp: false
			})
			// Call callback function and say that is selection finish
			this.props.selectDotTwo()
			this.props.completeFormBulp()


			apiService.fetchTehnology(this.props.getLang(), this.props.carID, selectedBulpValue)
				.then(resTech => {
					this.setState({
						selectedTehnology: resTech.technologies
					})
					this.props.collectTechnologies(this.state.selectedTehnology)
				}).then(() => {

				})


			//Passing information is this step complete or not to allow jumping.
			this.props.jumpTwo(selectedBulpValue)
		}
	}

	//If everything selected then callback completeForm change state in App and passed to ProgresBar, and setState is this open or not.
	// allComplete = () => {
	// 	if (this.state.selectedBulpName !== '') {
	// 		this.setState({ openBulp: false })
	// 		this.props.completeFormBulp()


	// 	}
	// }
	////////////SELECTION END

	showPicture = (bulp) => {

		if (bulp === 2668 || bulp === 10745018) {
			return "icon-bulp headlight-bulb-low-beam"
		} else if (bulp === 2669 || bulp === 10745022) {
			return "icon-bulp headlight-bulb-high-beam"
		} else if (bulp === 2670) {
			return "icon-bulp parking-light-bulb"
		} else if (bulp === 2671) {
			return "icon-bulp headlight-bulb-high-beam-and-low-beam"
		} else if (bulp === 2672) {
			return "icon-bulp turn-signal-light-bulb-front"
		} else if (bulp === 2673) {
			return "icon-bulp side-marker-light-bulb-front"
		} else if (bulp === 2674) {
			return "icon-bulp turn-signal-light-bulb-rear"
		} else if (bulp === 2675) {
			return "icon-bulp tail-light-bulb"
		} else if (bulp === 2676) {
			return "icon-bulp center-high-mount-stop-light-bulb"
		} else if (bulp === 2677) {
			return "icon-bulp back-up-light-bulb"
		} else if (bulp === 2678) {
			return "icon-bulp fog-light-bulb-rear"
		} else if (bulp === 2679) {
			return "icon-bulp license-plate-light-bulb"
		} else if (bulp === 2680) {
			return "icon-bulp brake-light-bulb"
		} else if (bulp === 2681) {
			return "icon-bulp side-marker-light-bulb-front"
		} else if (bulp === 2682) {
			return "icon-bulp dome-light-bulb"
		} else if (bulp === 2683) {
			return "icon-bulp interior-door-light-bulb"
		} else if (bulp === 2684) {
			return "icon-bulp vanity-mirror-light-bulb"
		} else if (bulp === 2685) {
			return "icon-bulp trunk-or-cargo-area-light"
		} else if (bulp === 2686) {
			return "icon-bulp vanity-mirror-light-bulb"
		} else if (bulp === 3015) {
			return "icon-bulp courtesy-light-bulb"
		} else if (bulp === 3016) {
			return "icon-bulp map-light-bulb"
		} else if (bulp === 3017) {
			return "icon-bulp glove-box-light-bulb"
		} else if (bulp === 3018) {
			return "icon-bulp engine-compartment-light-bulb"
		} else if (bulp === 3066) {
			return "icon-bulp headlight-bulb-high-beam"
		} else if (bulp === 3073) {
			return "icon-bulp stepwell-light-bulb"
		} else if (bulp === 4360) {
			return "icon-bulp daytime-running-light-bulb"
		} else if (bulp === 4377) {
			return "icon-bulp side-marker-light-bulb-front"
		} else if (bulp === 4799) {
			return "icon-bulp cornering-light-bulb"
		}
		else {
			return "icon-bulp vanity-mirror-light-bulb"
		}
	}

	componentWillUpdate() {
		if (this.props.isCompleteBulp) return; //TODO consider usage of && this.state.selectedBulpName
		if (this.props.bulp && this.props.bulps && this.props.bulps.length > 0) {
			this.handleSelectedBulp(this.props.bulp)
			this.props.resetFromURL()
			return
		}
	}

	componentDidMount() {
		// this.allComplete()
		
		// On start we ask is checkbox-checked or not, it is not checked remove cookie and set start-states
		if (!this.props.useCookies) {
			this.setState({
				openBulp: true,
				selectedBulpName: '',
			});
		}
	}

	resetValues(isExpanded) {
		this.setState({
			openBulp: !isExpanded,
		})
	}

	renderBulp(title, bulps) {
		if (bulps == null || bulps.length === 0) {
			return ''
		} else
			return (
				<div>
					<h5 >{title}</h5>
					{(!!bulps) ? bulps.map((bulp, index) =>

						<li className="bulpList icon-left ikona" onClick={this.selectBulp} key={index} value={bulp.use_id} id={bulp.use_name} >
							<span className={this.showPicture(bulp.use_id)} ></span><p>{bulp.use_name}</p>
						</li>

					) : this.props.t("bulb.nothingFound")}
				</div>)
	}

	render() {
		let forward, exterior, interior;
		const { t } = this.props;
		if (this.props.bulps && this.props.bulps.length > 0) {
			forward = this.props.bulps.filter(bulp => bulp.position_id === 409)
			exterior = this.props.bulps.filter(bulp => bulp.position_id === 410)
			interior = this.props.bulps.filter(bulp => bulp.position_id === 411)
		} else {
			return ''
		}
		let isExpanded = this.state.openBulp
		let selected = this.state.selectedBulpName
		if (this.props && this.props.shouldForceExpand()) {
			this.setState({ openBulp: true, selectedBulpName: '' })
			isExpanded = true;
			selected = ''
		}
		return (
			<div className="vehicle-lamp-replacement-guide">
				<Panel id="collapsible-panel-example-1" expanded={isExpanded} className="row" onToggle={() => { }}>
					<Panel.Collapse className="col-xs-12">
						<Panel.Body>
							<div className="bulp-panel">
								<div className="row">
									<div className="col-md-6">
										<div className="bulp-panel-left">
												<h4>{t("bulb.bulbPosition")}</h4>
											{this.renderBulp(t("bulb.forward"), forward)}
											{this.renderBulp(t("bulb.exterior"), exterior)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="bulp-panel-right">
											{this.renderBulp(t("bulb.interior"), interior)}
										</div>
									</div>
								</div>
							</div>
						</Panel.Body>
					</Panel.Collapse>
					{/*Display + or - , toogle openBrand and show minus or plus*/}
					<div onClick={() => this.resetValues(isExpanded)} className={(isExpanded) ? "" : "col-xs-12"}>
						<div className={(isExpanded) ? " accordion-icon ms-icon_minus" : "accordion-icon ms-icon_plus"}>
						</div>
						{/* Display or not when accordion expand or colapse , and on change can open or collapse panel*/}
						<div className={(isExpanded || !selected) ? "none" : "display"} >
								<h4>{t("bulb.bulbPosition")}</h4>
							<p>{selected} <span className="change" onClick={() => this.resetValues(isExpanded)}>{t("bulb.change")}</span></p>
						</div>
					</div>
				</Panel>
			</div>

		)
	}
}

const cookieWrap = withCookies(Bulp);
export default withTranslation()(cookieWrap);
